export default "__VITE_ASSET__Cv77glN___"